import { render } from "./LoginLayout.vue?vue&type=template&id=d71408d4&ts=true"
import script from "./LoginLayout.vue?vue&type=script&lang=ts"
export * from "./LoginLayout.vue?vue&type=script&lang=ts"

import "./LoginLayout.vue?vue&type=style&index=0&id=d71408d4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__